<template>
  <div />
</template>

<script lang="ts" setup>
await navigateTo('/not-found')
</script>
